module.exports = __webpack_public_path__ + "assets/img/crayon10.19a4b814.png";